import setDebug from 'debug';
import memoize from 'lodash/memoize';

import { saveUserInfo } from 'src/gql/client-side/actions';
import type { UserInfo } from 'src/types';
import { isCypressTest } from 'src/utils/cypress';

import getSsoClient from './utils/getSsoClient';

const debug = setDebug('auth');

export const getToken: () => Promise<string> = () => {
  if (isCypressTest()) {
    const token = window.localStorage.getItem('__test_token');
    if (!token) {
      throw new Error('You need to set __test_token for cypress');
    }
    debug('Using test token', token);

    return Promise.resolve(token);
  }

  return getSsoClient().getToken() as Promise<string>;
};

export const getUserInfo: () => Promise<UserInfo> = memoize(() =>
  getSsoClient()
    .getUserInfo()
    // @ts-ignore likely tslint bug
    .then((data: UserInfo): UserInfo => {
      saveUserInfo(data);
      return data;
    }),
);

export const redirectToLogin = () => {
  debug('Calling ssoClient.login');
  getSsoClient().login();
};

export const checkSessionExist = async () => {
  if (!isCypressTest()) {
    const token = await getSsoClient().getToken();
    if (!token) {
      redirectToLogin();
    }
  }
};
